export enum SHIPMENT_TYPE {
  MANUAL = 0,
  AUTOMATICO = 1,
}
